import createDebug from 'debug';

const debug = createDebug('lib:tracking');

export const trackPageview = (path: string = window.location.pathname): void => {
  debug('send:pageview', path);

  if (window.ga) {
    window.ga('send', 'pageview', path);
  }
};

interface Event {
  action: string;
  category?: string;
  label?: string;
  value?: number;
  nonInteraction?: boolean;
  page?: string;
}

export const trackEvent = ({
  category = 'Event',
  action,
  value = 0,
  label,
  nonInteraction = false,
  page = window.location.pathname,
}: Event): void => {
  const payload = {
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
    eventValue: value,
    nonInteraction,
    page,
  };

  debug('send:event', payload);

  if (window.ga) {
    window.ga('send', 'event', payload);
  }
};
